function model(name) {
    return {
        /* GET LIST */
        LOAD_LIST: `${name}/LOAD_LIST`,
        LOAD_LIST_SUCCESS: `${name}/LOAD_LIST_SUCCESS`,
        LOAD_LIST_FAIL: `${name}/LOAD_LIST_FAIL`,

        /* GET */
        LOAD: `${name}/LOAD`,
        LOAD_SUCCESS: `${name}/LOAD_SUCCESS`,
        LOAD_FAIL: `${name}/LOAD_FAIL`,

        /* POST */
        CREATE: `${name}/CREATE`,
        CREATE_SUCCESS: `${name}/CREATE_SUCCESS`,
        CREATE_FAIL: `${name}/CREATE_FAIL`,

        /* PUT */
        EDIT: `${name}/EDIT`,
        EDIT_SUCCESS: `${name}/EDIT_SUCCESS`,
        EDIT_FAIL: `${name}/EDIT_FAIL`,

        /* DELETE */
        DELETE: `${name}/DELETE`,
        DELETE_SUCCESS: `${name}/DELETE_SUCCESS`,
        DELETE_FAIL: `${name}/DELETE_FAIL`,
    };
}

const actions = {
    LOGIN: "LOGIN",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAIL: "LOGIN_FAIL",

    REGISTER: "REGISTER",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    REGISTER_FAIL: "REGISTER_FAIL",

    RECOVER: "RECOVER",
    RECOVER_SUCCESS: "RECOVER_SUCCESS",
    RECOVER_FAIL: "RECOVER_FAIL",

    RESET: "RESET",
    RESET_SUCCESS: "RESET_SUCCESS",
    RESET_FAIL: "RESET_FAIL",

    LOGOUT: "LOGOUT",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    LOGOUT_FAIL: "LOGOUT_FAIL",

    CHANGE_LOCALE: "CHANGE_LOCALE",
    CHANGE_REGION: "CHANGE_REGION",
    CHANGE_COOKIES: "CHANGE_COOKIES",
    CHANGE_NEWSLETTER: "CHANGE_NEWSLETTER",
    CHANGE_LOGIN: "CHANGE_LOGIN",
    CHANGE_FLOOR: "CHANGE_FLOOR",
    CHANGE_FAQ: "CHANGE_FAQ",
    CHANGE_SEARCH: "CHANGE_SEARCH",
    CHANGE_MOBILE_FLOOR: "CHANGE_MOBILE_FLOOR",
    CHANGE_MOBILE_FAQ: "CHANGE_MOBILE_FAQ",
    CHANGE_MOBILE_CLASSE: "CHANGE_MOBILE_CLASSE",
    CHANGE_MOBILE_MENU: "CHANGE_MOBILE_MENU",
    CHANGE_SPLASH: "CHANGE_SPLASH",

    CHANGE_ARTISTICS_BOOKING: "CHANGE_ARTISTICS_BOOKING",
    CHANGE_CLAIM_BOOKING: "CHANGE_CLAIM_BOOKING",
    CHANGE_TECHNICS_BOOKING: "CHANGE_TECHNICS_BOOKING",
    CHANGE_SPACES_BOOKING: "CHANGE_SPACES_BOOKING",
    CHANGE_DYNAMIC_BOOKING: "CHANGE_DYNAMIC_BOOKING",

    LOAD_USER_ME: "LOAD_USER_ME",
    LOAD_USER_ME_SUCCESS: "LOAD_USER_ME_SUCCESS",
    LOAD_USER_ME_FAIL: "LOAD_USER_ME_FAIL",

    UPDATE_USER_ME: "UPDATE_USER_ME",
    UPDATE_USER_ME_SUCCESS: "UPDATE_USER_ME_SUCCESS",
    UPDATE_USER_ME_FAIL: "UPDATE_USER_ME_FAIL",

    DELETE_USER_ME: "DELETE_USER_ME",
    DELETE_USER_ME_SUCCESS: "DELETE_USER_ME_SUCCESS",
    DELETE_USER_ME_FAIL: "DELETE_USER_ME_FAIL",

    SUBSCRIBE_NEWSLETTER: "SUBSCRIBE_NEWSLETTER",
    SUBSCRIBE_NEWSLETTER_SUCCESS: "SUBSCRIBE_NEWSLETTER_SUCCESS",
    SUBSCRIBE_NEWSLETTER_FAIL: "SUBSCRIBE_NEWSLETTER_FAIL",

    OPEN_CALLS: {
        LOAD_ACTIVE: "OPEN_CALLS/LOAD_ACTIVE",
        LOAD_ACTIVE_SUCCESS: "OPEN_CALLS/LOAD_ACTIVE_SUCCESS",
        LOAD_ACTIVE_FAIL: "OPEN_CALLS/LOAD_ACTIVE_FAIL",

        LOAD_APPLICATIONS: "OPEN_CALLS/LOAD_APPLICATIONS",
        LOAD_APPLICATIONS_SUCCESS: "OPEN_CALLS/LOAD_APPLICATIONS_SUCCESS",
        LOAD_APPLICATIONS_FAIL: "OPEN_CALLS/LOAD_APPLICATIONS_FAIL",

        CREATE_APPLICATIONS: "OPEN_CALLS/CREATE_APPLICATIONS",
        CREATE_APPLICATIONS_SUCCESS: "OPEN_CALLS/CREATE_APPLICATIONS_SUCCESS",
        CREATE_APPLICATIONS_FAIL: "OPEN_CALLS/CREATE_APPLICATIONS_FAIL",

        CREATE_DYNAMIC_APPLICATIONS: "OPEN_CALLS/CREATE_DYNAMIC_APPLICATIONS",
        CREATE_DYNAMIC_APPLICATIONS_SUCCESS: "OPEN_CALLS/CREATE_DYNAMIC_APPLICATIONS_SUCCESS",
        CREATE_DYNAMIC_APPLICATIONS_FAIL: "OPEN_CALLS/CREATE_DYNAMIC_APPLICATIONS_FAIL",
    },

    SPACES: {
        ...model("SPACES"),

        LOAD_SLOTS_AVAILABLE: "SPACES/LOAD_SLOTS_AVAILABLE",
        LOAD_SLOTS_AVAILABLE_SUCCESS: "SPACES/LOAD_SLOTS_AVAILABLE_SUCCESS",
        LOAD_SLOTS_AVAILABLE_FAIL: "SPACES/LOAD_SLOTS_AVAILABLE_FAIL",

        DELETE_RESERVATIONS: "SPACES/DELETE_RESERVATIONS",
        DELETE_RESERVATIONS_SUCCESS: "SPACES/DELETE_RESERVATIONS_SUCCESS",
        DELETE_RESERVATIONS_FAIL: "SPACES/DELETE_RESERVATIONS_FAIL",
    },

    BLOG: {
        ...model("BLOG"),

        LOAD_TAGS: "BLOG/LOAD_TAGS",
        LOAD_TAGS_SUCCESS: "BLOG/LOAD_TAGS_SUCCESS",
        LOAD_TAGS_FAIL: "BLOG/LOAD_TAGS_FAIL",

        LOAD_RELATED: "BLOG/LOAD_RELATED",
        LOAD_RELATED_SUCCESS: "BLOG/LOAD_RELATED_SUCCESS",
        LOAD_RELATED_FAIL: "BLOG/LOAD_RELATED_FAIL",
    },

    PAGES: model("PAGES"),
    FAQ: model("FAQ"),
    SEARCH: model("SEARCH"),
    TEAM: model("TEAM"),
    ARTISTS: model("ARTISTS"),

    EVENTS: model("EVENTS"),
    LESSONS: model("LESSONS"),
    TICKERS: model("TICKERS"),

    SPACE_RESERVATIONS: {
        ...model("SPACE_RESERVATIONS"),

        DELETE_SLOT: "SPACE_RESERVATIONS/DELETE_SLOT",
        DELETE_SLOT_SUCCESS: "SPACE_RESERVATIONS/DELETE_SLOT_SUCCESS",
        DELETE_SLOT_FAIL: "SPACE_RESERVATIONS/DELETE_SLOT_FAIL",
    },
};

export default actions;
